module.exports = __webpack_public_path__ + "static/media/spinner-solid.becded27.svg";